import { render, staticRenderFns } from "./cModalCategory.vue?vue&type=template&id=268f45a5"
import script from "./cModalCategory.vue?vue&type=script&lang=js"
export * from "./cModalCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports